import * as React from 'react';
const SvgLightning = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 15 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.054 9.338l5.166 1.365-8.063 9.096 1.989-7.53-5.497-1.452L10.072 1.7 8.054 9.338z"
        stroke="currentColor"
        strokeWidth={1.65}
      />
    </svg>
  );
};
const MemoSvgLightning = React.memo(SvgLightning);
export default MemoSvgLightning;
